<script setup lang="ts">
import Page from '~/enums/page'
</script>

<template>
  <NuxtLink
    class="
      flex max-w-[112px] flex-col items-center rounded-2xl bg-main-green py-3 pl-[23px] pr-6 text-white
      !no-underline md:max-w-[133px] md:px-8 md:pb-[14px] md:pt-[10px]
    "
    :to="Page.Cart"
  >
    <b class="text-base font-medium tracking-[-0.01em] md:leading-normal">В&nbsp;корзине</b>

    <span class="hidden text-xs leading-none md:block">Перейти</span>
  </NuxtLink>
</template>
